module.exports = __webpack_public_path__ + "img/g_TimberCove7.9540231b.jpg";